import { BILLING_CYCLE, NO_NEED_CHANGE_PRICE_CYCLE } from '@/common/constants';
import { billingCycleToValueMap } from '@/utils';
import { getDiscountedMonthPlanUnit, getMergedBilledText } from '@/common/product-unit';
import { isString } from 'lodash';
import { getEffectiveAmount } from '@/utils/downsell-price';
import { separators } from '@/utils/money';

export default {
  methods: {
    useSmallSize(text) {
      return isString(text) && text.length > 5
    },
    showBilledText(cycle) {
      return billingCycleToValueMap[cycle]
    },
    // will deprecate
    getMergedBilledText_deprecation(billingCycle, amount, unit) {
      const unitText = this.getDiscountedMonthPlanUnit(unit)
      if (this.showBilledText(billingCycle)) {
        if (billingCycle === BILLING_CYCLE.ANNUAL_TERM_MONTHLY) {
          return `${unitText}, ${this.$t('billing.bill_12_payments')}, ${this.getBillText(billingCycle)}`
        } else {
          return `${unitText}, <span class="opc-price-total-bill">${this.getBilledPriceIfNeed(billingCycle, amount)}</span> ${this.getBillText(billingCycle)}`
        }
      } else {
        return `${unitText}`
      }
    },
    getPriceOfMonth(amountCents, billingCycle, options = {}) {
      return this.$priceByMonth(amountCents, billingCycle, options);
    },
    getPriceOfMonthWithDownsell(plan, options = {}) {
      const effectiveAmount = getEffectiveAmount(plan);
      return this.$priceByMonth(effectiveAmount, plan.billing_cycle, options);
    },
    getDiscountedMonthPlanUnit(unit) {
      return getDiscountedMonthPlanUnit(unit);
    },
    getBilledPriceIfNeed(billingCycle, amount) {
      if (NO_NEED_CHANGE_PRICE_CYCLE.includes(billingCycle)) {
        return '';
      }
      return this.$money(amount, { forceDiff: true })
    },
    getBillText(billingCycle) {
      if (NO_NEED_CHANGE_PRICE_CYCLE.includes(billingCycle)) {
        return this.$t('billing.bill_monthly')
      }
      switch (billingCycle) {
        case BILLING_CYCLE.ANNUAL_TERM_MONTHLY:
          return this.$t('billing.bill_monthly')
        case BILLING_CYCLE.ANNUAL:
          return this.$t('billing.bill_annually')
        case BILLING_CYCLE.QUARTERLY:
          return this.$t('billing.bill_quarterly')
        case BILLING_CYCLE.TWO_YEARS:
          return this.$t('billing.bill_two_years')
        case BILLING_CYCLE.THREE_YEARS:
          return this.$t('billing.bill_three_years')
      }
      return ''
    },
    formatPrice(priceObject) {
      const { place, space, decimal: decimalSeparator } = separators();
        
      const symbol = `${priceObject?.currency?.symbol}`;
      const isSymbolPrefix = place === 'begin';
      const price = `${priceObject.integer}${priceObject?.decimal ? `${decimalSeparator}${priceObject?.decimal}`: ''}`;

      return isSymbolPrefix ? 
        `${symbol}${space ? ' ' : ''}${price}` : 
        `${price}${space ? ' ' : ''}${symbol}`;
    },
    getFormattedPriceOfMonthWithDownsell(plan, options = {}) {
      const priceObject = this.getPriceOfMonthWithDownsell(plan, options);
      return this.formatPrice(priceObject);
    },
    getFormattedPriceOfMonth(plan, options = {}) {
      const priceObject = this.getPriceOfMonth(plan.amount, plan.billing_cycle, options);
      return this.formatPrice(priceObject);
    },
    // ZOOM-797378
    ariaPriceOfMonthForLabel(plan) {
      try {
        const priceObject = this.getPriceOfMonthWithDownsell ?
        this.getPriceOfMonthWithDownsell(plan, { forceDiff: true }) :
        this.getPriceOfMonth(plan.amount, plan.billing_cycle, { forceDiff: true });
        return this.formatPrice(priceObject);
      } catch(e) {
        return '';
      }
    },
    // for subscription cycle selection UI (update style in v3)
    getMergedBilledText(billingCycle, amount, unit) {
      return getMergedBilledText(billingCycle, amount, unit);
    }
  }
}
